import { client } from './client';

export const getQuote = (payload) =>
  client('quotes', {
    method: 'POST',
    body: payload
  });
